
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"42"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"그룹 2245","fill":"none","stroke-miterlimit":"10"}},[_c('g',{attrs:{"data-name":"사각형 2966","stroke":"#000","stroke-width":"2"}},[_c('path',{attrs:{"stroke":"none","d":"M0 12h32v30H0z"}}),_c('path',{attrs:{"d":"M1 13h30v28H1z"}})]),_c('g',{attrs:{"data-name":"그룹 2242"}},[_c('g',{attrs:{"data-name":"패스 1380"}},[_c('path',{attrs:{"d":"M4 10l6-10 6 10z"}}),_c('path',{attrs:{"d":"M12.468 8L10 3.887 7.533 8h4.935M16 10H4l6.001-10L16 10z","fill":"#000"}})]),_c('g',{attrs:{"data-name":"패스 1381"}},[_c('path',{attrs:{"d":"M28 0l-6 10-6-10z"}}),_c('path',{attrs:{"d":"M19.532 2L22 6.112 24.467 2h-4.935M16 0h12l-6.001 10L16 0z","fill":"#000"}})])]),_c('g',{attrs:{"data-name":"그룹 2243","stroke":"#000","stroke-width":"2","transform":"translate(-1173.792 -210.023)"}},[_c('circle',{attrs:{"data-name":"타원 274","cx":"2","cy":"2","r":"2","transform":"translate(1182.792 228.938)"}}),_c('path',{attrs:{"data-name":"패스 1382","d":"M1182.792 246.938v-9a2 2 0 114 0v9"}})]),_c('g',{attrs:{"data-name":"그룹 2244","stroke":"#000","stroke-width":"2","transform":"translate(-1173.792 -210.023)"}},[_c('circle',{attrs:{"data-name":"타원 275","cx":"2","cy":"2","r":"2","transform":"translate(1192.792 228.938)"}}),_c('path',{attrs:{"data-name":"패스 1383","d":"M1192.792 246.938v-9a2 2 0 114 0v9"}})])])])
          )
        }
      }
    